<script setup>
import { ref, reactive } from 'vue';
import TabNavigator from "@/Shared/Navigation/TabNavigator";
import ContactPanner from "@/Shared/ContactPanner";

let props = defineProps({
    data: Object,
});

let tabNavigation = [
    { name: 'Build', href: route('platform.build'), current: false },
    { name: 'APIs', href: route('platform.apis'), current: false },
    { name: 'Nodes', href: route('platform.nodes'), current: true },
];

</script>

<template>
    <div class="w-full relative">
        <TabNavigator :tabs="tabNavigation" />
        <h1 class="text-white text-3xl font-bold mt-12 sm:mt-16 text-center px-2 max-w-lg m-auto font-bold">{{data.title}}</h1>
        <div class="mt-28 sm:mt-20 relative">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-y-5 gap-x-5">
                <div class="flex flex-col rounded-2xl bg-wgn-blue-1 p-6" v-for="card in data.cards">
                    <div class="relative flex-1">
                        <h3 class="text-2xl font-medium text-white">{{card.title}}</h3>
                        <p class="mt-2 text-base text-white text-opacity-60">{{card.description}}</p>
                        <img class="mt-6 flex-shrink-0 w-full max-h-[400px] object-cover rounded-lg" :src="card.image" :alt="card.title">
                    </div>
                </div>
            </div>
        </div>
        <!--            -->
        <div class="mt-20">
            <ContactPanner></ContactPanner>
        </div>
    </div>
</template>
